import React, { useEffect } from "react";
import { useState, useRef } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import { mainTable } from "../css/Common";
import Buttons from "../components/Buttons";
import Image1 from "../image/Image1.jpeg";
import Image3 from "../image/Image3.jpeg";
import Image2 from "../image/Image2.jpeg";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { BindAPI, IUDAPI, BindPostAPI } from "../services/APIConnection";
import FileUpload from "../ReusableComponents/FileUpload";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
const ConfirmBookingPopUp = ({
  data,
  data1,
  data2,
  data3,
  isOpen,
  isSubmit,
  viewPopUp,
}) => {
  console.log("data1", data, data1);
  const [bookingGuestDetails, setBookingGuestDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [lostreasondropdown, setlostreasondropdown] = useState([]);
  const [selectedRooms, setSelectedRooms] = useState({});
  const [formData, setFormData] = useState({});
        const [IsOpen, setIsOpen] = useState(false);
  var clientId = sessionStorage.getItem("MstClientId");

  const cancel = () => {
    isOpen(false);
    isSubmit(true);
    Clear();
    setIsLoading(false);
    setSubmitBtnDisabled(false);
  };
  const Clear = () => {
    // data2(false);
    const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD" format
    setFormData({
      enquiryDate: null,
      enquiryId: null,
      bookingId: null,
      bookingDate: today,
      bookingFrom: null,
      bookingTo: null,
      noOfDays: null,
      firstName: null,
      lastName: null,
      mobileNumber: null,
      country: null,
      state: null,
      city: null,
      streetDoorNo: null,
      area: null,
      pincode: null,
      sourceType: null,
      source: null,
      contactNumber: null,
      idType: null,
      idValue: null,
      
      email:null,
      bookingTotalAmount: null,
      bookingReceivedAmount: null,
      bookingBalanceAmount: null,
      bookingPaymentType: null,
      bookingPaymentReferenceNumber: null,
      showImage: null,
    });
    setFormDataError({
      enquiryDateError: "",
      enquiryIdError: "",
      bookingIdError: "",
      bookingDateError: "",
      bookingFromError: "",
      bookingToError: "",
      noOfDaysError: "",
      firstNameError: "",
      lastNameError: "",
      mobileNumberError: "",
      countryError: "",
      stateError: "",
      cityError: "",
      streetDoorNoError: "",
      areaError: "",
      pincodeError: "",
      sourceTypeError: "",
      sourceError: "",
      contactNumberError: "",
      idTypeError: "",
      idValueError: "",
      showImageError: "",
      bookingPaymentTypeError: "",
    });
    
  };
  useEffect(() => {
    Clear();
    if (data) {
      const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD" format

      setFormData({
        enquiryDate: data?.EnquiryDate || null,
        enquiryId: data?.EnquiryNo || null,
        bookingId: data?.BookingNo || null,
        bookingDate: today,
        bookingFrom: data?.BookingFrom || null,
        bookingTo: data?.BookingTo || null,
        noOfDays: data?.NoOfDays || null,
        firstName: data?.BookingPersonFirstName || null,
        lastName: data?.BookingPersonLastName || null,
        mobileNumber: data?.BookingPersonMobileNumber || null,
        country: data?.BookingPersonMstCountryId || null,
        state: data?.BookingPersonMstStateId || null,
        city: data?.BookingPersonMstCityId || null,
        streetDoorNo: data?.BookingPersonStreetDoorNo || null,
        area: data?.BookingPersonArea || null,
        pincode: data?.BookingPersonPincode || null,
        sourceType: data?.MstSourceId || "",
        source: data?.Source || null,
        contactNumber: data?.BookingContactNumber || null,
        idType: data?.MstIdProofId || "",
        idValue: data?.IdNumber || null,
        email:data?.Email,
        bookingTotalAmount: parseInt(data?.TotalAmount, 10) || null,
        bookingReceivedAmount: parseInt(data?.ReceivedAmount, 10) || null,
        bookingBalanceAmount: parseInt(data?.BalanceAmount, 10) || null,
        bookingPaymentType: data?.PaymentType || "",
        bookingPaymentReferenceNumber: data?.PaymentRefNumber || null,
        showImage: data?.ShowImage,
      });
    }
  }, [data]); // runs every time `data` changes
  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    
    const data = {
      mstClientId: clientId,
    };

    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    if (response && response.data) {
      console.log("Log response enquiry values", response);
      const LostReasonId = response.data.Table8.map((item) => ({
        value: item.MstLostReasonId,
        label: item.LostReason,
      }));

      setlostreasondropdown(LostReasonId);
    } else {
      //setBindEnquiryData([]);
    }
  };
  const [roomSelectionError, setRoomSelectionError] = useState(null);
  const [tableDataError, setTableDataError] = useState(null);
  const [formDataError, setFormDataError] = useState({
    enquiryDateError: "",
    enquiryIdError: "",
    bookingIdError: "",
    bookingDateError: "",
    bookingFromError: "",
    bookingToError: "",
    noOfDaysError: "",
    firstNameError: "",
    lastNameError: "",
    mobileNumberError: "",
    countryError: "",
    stateError: "",
    stateNameError: "",
    cityNameError: "",
    cityError: "",
    streetDoorNoError: "",
    areaError: "",
    pincodeError: "",
    sourceTypeError: "",
    sourceError: "",
    contactNumberError: "",
    idTypeError: "",
    emailError:"",
    idValueError: "",
    showImageError: "",
    bookingPaymentTypeError: "",
  });

  const [countrydropdown, setcountrydropdown] = useState(data1[0] || []);

  const [statedropdown, setstatedropdown] = useState(data1[1] || []);

  const [referralSourceDropdown, setReferralSourceDropdown] = useState([]);

  const [iddropdown, setiddropdown] = useState([]);

  const [paymenttypedropdown, setPaymentTypeDropdown] = useState([]);

  const fieldLabels = {
    country: { label: "Country", type: "select-one" },
    state: { label: "State", type: "select-one" },
    districts: { label: "Districts", type: "select-one" },
    city: { label: "City", type: "select-one" },
    streetDoorNo: { label: "Door No & Street Name", type: "text" },
    area: { label: "Area", type: "text" },
    pincode: { label: "Pin Code", type: "text" },
    sourceType: { label: "Source Type", type: "select-one" },
    source: { label: "Source", type: "text" },
    contactNumber: { label: "Contact Number", type: "text" },
    adults: { label: "Adults", type: "select-one" },
    children: { label: "Children", type: "select-one" },
    idType: { label: "ID-Proof", type: "select-one" },
    idvalue: { label: "ID-Number", type: "text" },
    bookingReceivedAmount: { label: "Received Amount", type: "text" },
    bookingPaymentType: { label: "Payment Type", type: "select-one" },
    bookingPaymentReferenceNumber: {
      label: "Payment Reference Number",
      type: "text",
    },
  };

  const handletableDataChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? parseInt(selectedOption.value) : 0;

    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];

      // Update the specific column value
      updatedData[rowIndex] = {
        ...updatedData[rowIndex],
        [columnName]: value,
      };

      // Get both values (treat missing/invalid as 0)
      const specialtariff =
        parseFloat(updatedData[rowIndex].specialtariff) || 0;
      const numberofrooms = parseInt(updatedData[rowIndex].Numberofrooms) || 0;

      if (["specialtariff", "Numberofrooms"].includes(columnName)) {
        if (numberofrooms > updatedData[rowIndex].NumberofEnquiryRooms) {
          toast.dismiss();
          toast.error(
            `${updatedData[rowIndex].Numberofrooms} rooms is more than number of enquiry rooms (${updatedData[rowIndex].NumberofEnquiryRooms})`,
            // `Only ${updatedData[rowIndex].AvailableRooms} rooms are available for ${updatedData[rowIndex].RoomType}`,
            {
              duration: 5000,
              position: "top-center",
            }
          );
          updatedData[rowIndex].Numberofrooms = 0;
        }
        updatedData[rowIndex].amount = specialtariff * numberofrooms;
      }

      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setBookingGuestDetails(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (data3?.length > 0) {
      setTableData(data3);

      const initialSelections = {};
      data3.forEach((room, index) => {
        if (room.SelectedRoomIds) {
          initialSelections[index] = room.SelectedRoomIds.split(",")
            .map((id) => Number(id.trim())) // ✅ force to number
            .filter((id) => !isNaN(id));
        } else {
          initialSelections[index] = [];
        }
      });

      setSelectedRooms(initialSelections);
    } else {
      setTableData([]);
      setSelectedRooms({});
    }
  }, [data3]);

  useEffect(() => {
    const total = tableData.reduce(
      (sum, row) => sum + (Number(row.amount) || 0),
      0
    );

    setFormData((prev) => ({
      ...prev,
      bookingTotalAmount: total,
    }));
  }, [tableData]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const field = fieldLabels[name];
    if (!field) return;

    const label = field.label;
    const type = field.type;

    const message =
      value.trim() === ""
        ? type === "select-one"
          ? `Select ${label}`
          : `Enter ${label}`
        : "";

    setFormDataError((prevErrors) => ({
      ...prevErrors,
      [`${name}Error`]: message,
    }));
  };

  const validateForm = (action) => {
    let fieldsToValidate = [];
    const newErrors = {};
    let formValid = true;

    if (action === "save") {
      fieldsToValidate = ["amountpaid", "payrefnumber", "paymenttype"];
    }

    fieldsToValidate.forEach((key) => {
      const value = formData[key] || "";
      const field = fieldLabels[key];

      if (!field) return; // skip unknown fields

      const { label, type } = field;

      if (value.trim() === "") {
        const message =
          type === "select-one" ? `Select ${label}` : `Enter ${label}`;
        newErrors[key] = message;
        formValid = false;
      }
    });

    setFormDataError(newErrors); // <- make sure this updates your UI
    return formValid; // <- return the result for the calling function
  };
  useEffect(() => {
    if (formData.state === 0) {
      // Clear dropdown city
      setFormData((prev) => ({
        ...prev,
        city: 0,
      }));

      // Clear dropdown validation errors
      setFormDataError((prev) => ({
        ...prev,
        cityError: "",
        stateError: "",
      }));
    }
  }, [formData.state]);
  console.log("confirmFormData", formData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSave = () => {
    validateForm("save");
  };
  if (!data) return null;

  const handleToggleRoom = (roomIndex, roomId) => {
    setSelectedRooms((prev) => {
      const current = prev[roomIndex] || [];
      const isSelected = current.includes(roomId);

      const updatedSelection = isSelected
        ? current.filter((id) => id !== roomId)
        : [...current, roomId];

      // ✅ Update tableData with selectedRooms string for the specific row
      setTableData((prevTable) => {
        const newTable = [...prevTable];
        if (newTable[roomIndex]) {
          newTable[roomIndex] = {
            ...newTable[roomIndex],
            selectedRooms: updatedSelection.join(","), // Convert to "1,2,3"
          };
        }
        return newTable;
      });

      // ✅ Return updated selectedRooms state
      return {
        ...prev,
        [roomIndex]: updatedSelection,
      };
    });
  };
  const requiredFields = [
    "Numberofrooms",
    "numberofadults",
    "numberofchildren",
    "Tariff",
    "specialtariff",
  ];
  const validateTableData = () => {
    for (let i = 0; i < tableData.length; i++) {
      for (let field of requiredFields) {
        if (
          tableData[i][field] === "" ||
          tableData[i][field] === null ||
          tableData[i][field] === undefined
        ) {
          const error = `Row ${i + 1}: ${field} is required`;
          setTableDataError("All the fields are mandatory.");

          return false;
        } else {
          setTableDataError(null);
        }
      }
    }
    return true;
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    
    
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    console.log("tableData", tableData);
    // validateTableData();
    const isTableValid = validateTableData();
    let roomError = null;
    tableData.forEach((room) => {
      const selectedRooms = room.selectedRooms || room.SelectedRoomIds || "";

      const selectedCount = selectedRooms
        ? selectedRooms.split(",").filter((id) => id.trim() !== "").length
        : 0;
      setRoomSelectionError(null);
      if (selectedCount !== room.Numberofrooms) {
        roomError = `Error: For RoomType "${room.RoomType}", selected rooms (${selectedCount}) do not match required (${room.Numberofrooms}).`;
        console.error(
          `Error: For RoomType "${room.RoomType}", selected rooms (${selectedCount}) do not match required (${room.Numberofrooms}).`
        );
        setRoomSelectionError(
          `Error: For RoomType "${room.RoomType}", selected rooms (${selectedCount}) do not match required (${room.Numberofrooms}).`
        );
        return;
      }
    });
    const isFormError = {
      ...formDataError,

      bookingDateError: formData.bookingDate ? "" : "Select Booking Date",
      bookingFromError: formData.bookingFrom ? "" : "Select Booking From",
      bookingToError: formData.bookingTo ? "" : "Select Booking To",
      noOfDaysError: formData.noOfDays ? "" : "Enter Number of Days",
      firstNameError: formData.firstName ? "" : "Enter First Name",
      // lastNameError: formData.lastName ? "" : "Enter Last Name",
      mobileNumberError: formData.mobileNumber
        ? /^[0-9+\-\s]{7,15}$/.test(formData.mobileNumber)
          ? ""
          : "Only digits, +, - and spaces allowed (7 to 15 characters)"
        : "Enter Mobile Number",
      countryError: formData.country ? "" : "Select Country",
      stateError:
        formData.state !== null &&
        formData.state !== undefined &&
        formData.state !== ""
          ? ""
          : "Select State1",
      cityError:
        formData.city !== null &&
        formData.city !== undefined &&
        formData.city !== ""
          ? ""
          : "Select City1",
      stateNameError: formData.state == 0 ? formData.statename ? "" : "Enter State Name" : "",
      cityNameError:
        formData.city == 0 ? formData.cityname ? "" : "Enter City Name" :"",
      streetDoorNoError: formData.streetDoorNo
        ? ""  
        : "Enter Door No & Street Name",
      areaError: formData.area ? "" : "Enter Area",
      pincodeError: formData.pincode ? "" : "Enter Pin Code",
      sourceTypeError: formData.sourceType > 0 ? "" : "Select Source Type",
      sourceError: formData.source ? "" : "Enter Source",
      contactNumberError: formData.contactNumber
        ? /^[0-9+\-\s]{7,15}$/.test(formData.contactNumber)
          ? ""
          : "Only digits, +, - and spaces allowed (7 to 15 characters)"
        : "Enter Contact Number",
      idTypeError: formData.idType ? "" : "Select ID-Proof",
      idValueError: formData.idValue ? "" : "Enter ID-Number",
      bookingReceivedAmountError: formData.bookingReceivedAmount
        ? ""
        : "Enter Received Amount",
      bookingPaymentTypeError: formData.bookingPaymentType
        ? ""
        : "Select Payment Type",
      // bookingPaymentReferenceNumberError: formData.bookingPaymentReferenceNumber
      //   ? ""
      //   : "Enter Payment Reference Number",
      // showImageError: formData.showImage ? "" : "Upload Image",
    };
    setFormDataError(isFormError);
    const isFormValid = Object.values(isFormError).every((err) => err === "");
    if (isFormValid && roomError == null && tableDataError == null && isTableValid) {
      const data = {
        enquiryDate: formData?.enquiryDate,
        enquiryId: formData?.enquiryId,
        bookingId: formData?.bookingId,
        bookingDate: formData?.bookingDate,
        bookingFrom: formData?.bookingFrom,
        bookingTo: formData?.bookingTo,
        noOfDays: formData?.noOfDays,
        firstName: formData?.firstName,
        lastName: formData?.lastName,
        mobileNumber: formData?.mobileNumber,
        mstCountryId: formData?.country,
        mstStateId: formData?.state,
        stateName: formData?.statename,
        cityName: formData?.cityname,
        mstCityId: formData?.city,
        streetDoorNo: formData?.streetDoorNo,
        area: formData?.area,
        pincode: formData?.pincode,
        sourceType: formData?.sourceType,
        source: formData?.source,
        contactNumber: formData?.contactNumber,
        idType: formData?.idType,
        idValue: formData?.idValue,
        // email:formData?.email,
        bookingTotalAmount: formData?.bookingTotalAmount,
        bookingReceivedAmount: formData?.bookingReceivedAmount ?? 0,
        bookingBalanceAmount: formData?.bookingBalanceAmount,
        bookingPaymentType: formData?.bookingPaymentType,
        bookingPaymentReferenceNumber: formData?.bookingPaymentReferenceNumber,
        bookingData: JSON.stringify(tableData),
        showImage: formData?.showImage,
        flag: flag,
        createdBy: parseInt(createdBy, 10),
      };
      const response = await IUDAPI(data, "Enquiry/IUDConfirmBooking");
      if (flag == 1) {
        //if flag ==1 , add
        if (response.data.Table[0].Result === "S") {
          toast.dismiss();
          toast.success("Room booking successful", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.dismiss();
          toast.error("Failed to book room", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
      if (flag == 2) {
        //if flag ==1 , add
        if (response.data.Table[0].Result === "M") {
          toast.dismiss();
          toast.success("Room booking updated successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.dismiss();
          toast.error("Failed to update Room booking", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false);
      setIsOpen(true);
    }
  };

  const handleShowImage = (showImage) => {
    // showImage &&
    setFormData({
      ...formData,
      showImage: showImage || "",
    });
    setFormDataError({
      ...formDataError,
      showImageError: "",
    });
  };
  const filteredStates = [
    ...(data1[1]?.filter((x) => x.MstCountryId == formData?.country) || []),
    { value: 0, label: "Others" },
  ];
  const filteredCity = [
    ...(data1[6]?.filter((x) => x.MstStateId == formData?.state) || []),
    { value: 0, label: "Others" },
  ];

  return (
    <>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div className="mx-auto p-8 maxw-7xl">
        <div className={mainTable.grid3}>
          <InputText
            inputType="date"
            title="Enquiry Date"
            name="enquiryDate"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.enquiryDate}
            content={
              formData?.enquiryDate ? formData.enquiryDate.substring(0, 10) : ""
            }
            placeholder="Enter Enquiry Date"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.EnquiryDate}
          />
          <InputText
            inputType="text"
            title="Enquiry ID"
            name="enquiryId"
            content={formData?.enquiryId || null}
            disabled={true}
            placeholder="ENQ-2025-000001"
            // tabIndex="11"
            isRequired={true}
          />

          <InputText
            inputType="text"
            title="Booking ID"
            name="bookingId"
            content={formData?.bookingId || null}
            placeholder="BKG-2025-000001"
            disabled={true}
            // tabIndex="8"
            isRequired={true}
          />

          <InputText
            inputType="date"
            title="Booking Date"
            name="bookingDate"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.bookingDate || null}
            content={
              formData?.bookingDate ? formData.bookingDate.substring(0, 10) : ""
            }
            // content={formData?.bookingdate}
            placeholder="Enter Booking Date"
            disabled={false}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.bookingDateError}
            max={new Date().toISOString().split("T")[0]}
          />

          <InputText
            inputType="date"
            title="Booking From"
            name="bookingFrom"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.bookingFrom || ""}
            content={
              formData?.bookingFrom ? formData.bookingFrom.substring(0, 10) : ""
            }
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.bookingFromError}
          />
          <InputText
            inputType="date"
            title="Booking To"
            name="bookingTo"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.bookingTo || ""}
            content={
              formData?.bookingTo ? formData.bookingTo.substring(0, 10) : ""
            }
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.bookingToError}
          />
          <InputText
            inputType="text"
            title="Number of Days"
            name="noOfDays"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.noOfDays || ""}
            placeholder="Enter Number of Days"
            disabled={true}
            // tabIndex="9"
            classStar="text-red-500"
            isRequired={true}
            errorMessage={formDataError.noOfDaysError}
          />

          <InputText
            inputType="text"
            title="First Name"
            name="firstName"
            content={formData?.firstName || ""}
            controlFunc={handleInputChange}
            controlFuncBlur={(e) => {
              const value = formData?.firstName?.trim() || "";

              const error = !value
                ? "Enter First Name"
                : value.length < 2
                ? "Minimum 2 characters required"
                : value.length > 100
                ? "Maximum 100 characters allowed"
                : /^[A-Za-z.'\- ]+$/.test(value)
                ? ""
                : "Only alphabets, dot, apostrophe, hyphen, and space allowed";

              setFormDataError((prev) => ({
                ...prev,
                firstNameError: error,
              }));
            }}
            disabled={false}
            maxLength={100}
            // tabIndex="1"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.firstNameError}
          />

          <InputText
            inputType="text"
            title="Last Name"
            name="lastName"
            disabled={false}
            content={formData?.lastName || ""}
            controlFunc={handleInputChange}
            // tabIndex="2"
            maxLength={100}
            isRequired={true}
            // classStar="text-red-500"
            controlFuncBlur={(e) => {
              const value = formData?.lastName?.trim() || "";

              const error = !value
                ? ""
                : value.length < 1
                ? "Minimum 1 characters required"
                : value.length > 100
                ? "Maximum 100 characters allowed"
                : /^[A-Za-z.'\- ]+$/.test(value)
                ? ""
                : "Only alphabets, dot, apostrophe, hyphen, and space allowed";

              setFormDataError((prev) => ({
                ...prev,
                lastNameError: error,
              }));
            }}
            errorMessage={formDataError.lastNameError}
          />

          <InputText
            inputType="text"
            title="Mobile Number"
            name="mobileNumber"
            content={formData?.mobileNumber || ""}
            controlFunc={(e) => {
              const value = e.target.value;
              // ✅ Allow only digits, +, -, and space while typing
              if (/^[0-9+\-\s]*$/.test(value)) {
                handleInputChange(e);
              }
            }}
            controlFuncBlur={(e) => {
              setFormDataError((formDataError) => ({
                ...formDataError,
                mobileNumberError:
                  formData.mobileNumber && formData.mobileNumber.length > 0
                    ? /^[0-9+\-\s]{7,15}$/.test(formData.mobileNumber)
                      ? ""
                      : "Only digits, +, - and spaces allowed (7 to 15 characters)"
                    : "Enter Contact Number",
              }));
            }}
            placeholder="Enter your mobile number"
            disabled={false}
            // tabIndex="3"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.mobileNumberError}
          />

          <AutoDropDown
            title="Country"
            placeholder="Select"
            options={data1[0] || []}
            name="country"
            Class="custom-class"
            // tabIndex="1"
            selectedOption={data1[0]?.find((x) => x.value == formData?.country)}
            classStar="text-red-500"
            controlFunc={(value) =>
              setFormData({
                ...formData,
                country: value.value,
              })
            }
            controlFuncBlur={() => {
              setFormDataError(() => ({
                ...formDataError,
                countryError: formData.country ? "" : "Select Country",
              }));
            }}
            errorMessage={formDataError.countryError}
          />

          <AutoDropDown
            title="State"
            placeholder="Select"
            options={filteredStates}
            name="state"
            Class="custom-class"
            // tabIndex="1"
            selectedOption={
              filteredStates?.find((x) => x.value == formData?.state) || null
            }
            classStar="text-red-500"
            controlFunc={(value) =>
              setFormData({
                ...formData,
                state: value.value,
              })
            }
            controlFuncBlur={() => {
              setFormDataError((prev) => ({
                ...prev,
                stateError: formData.state !== null ? "" : "Select State",
              }));
            }}
            errorMessage={formDataError.stateError}
            disabled={formData.state === 0}
          />

          <AutoDropDown
            title="City"
            placeholder="Select"
            options={filteredCity}
            name="city"
            Class="custom-class"
            // tabIndex="1"
            selectedOption={
              Array.isArray(data1[6])
                ? data1[6].find((x) => x.value == formData?.city)
                : null
            }
            classStar="text-red-500"
            controlFunc={
              formData.state == 0
                ? undefined
                : (value) =>
                    setFormData({
                      ...formData,
                      city: value.value,
                    })
            }
            controlFuncBlur={
              formData.state == 0
                ? undefined
                : () => {
                    setFormDataError((prev) => ({
                      ...prev,
                      cityError: formData.city ? "" : "Select City",
                    }));
                  }
            }
            errorMessage={formDataError.cityError}
            disabled={formData.state == 0 || formData.city == 0}
          />
          {formData.state == 0 && (
            <InputText
              inputType="text"
              title="State Name"
              name="statename"
              controlFunc={(e) =>
                setFormData({
                  ...formData,
                  statename: e.target.value,
                })
              }
              controlFuncBlur={() => {
                setFormDataError(() => ({
                  ...formDataError,
                  stateNameError: formData.statename ? "" : "Enter State",
                }));
              }}
              content={formData.statename}
              placeholder="Enter the State Name"
              disabled={false}
              // tabIndex="3"
              isRequired={true}
              errorMessage={formDataError.stateNameError}
              classStar="text-red-500"
              maxLength={15}
            />
          )}

          {(formData.state == 0 || formData.city == 0) && (
            <InputText
              inputType="text"
              title="City Name"
              name="cityname"
              controlFunc={(e) =>
                setFormData({
                  ...formData,
                  cityname: e.target.value,
                })
              }
              controlFuncBlur={() => {
                setFormDataError(() => ({
                  ...formDataError,
                  cityNameError: formData.cityname ? "" : "Enter City",
                }));
              }}
              content={formData.cityname}
              placeholder="Enter the City Name"
              disabled={false}
              // tabIndex="3"
              isRequired={true}
              errorMessage={formDataError.cityNameError}
              classStar="text-red-500"
              maxLength={15}
            />
          )}

          <InputText
            inputType="text"
            title="Door No & Street Name"
            name="streetDoorNo"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.streetDoorNo || ""}
            placeholder="Enter Door No & Street Name"
            disabled={false}
            maxLength={100}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.streetDoorNoError}
          />

          <InputText
            inputType="text"
            title="Area"
            name="area"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.area || ""}
            placeholder="Enter Area Name"
            disabled={false}
            maxLength={50}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.areaError}
          />

          <InputText
            inputType="text"
            title="Pin Code"
            name="pincode"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.pincode || ""}
            placeholder="Enter Pin Code"
            disabled={false}
            maxLength={10}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.pincodeError}
          />

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="sourceType"
              title="Source Type"
              type={"select-one"}
              classStar="text-red-500"
              options={data1[2] ?? []}
              selectedOption={formData?.sourceType}
              controlFunc={handleInputChange}
              // controlFuncBlur={handleBlur}
              controlFuncBlur={() => {
                setFormDataError(() => ({
                  ...formDataError,
                  sourceTypeError: formData.sourceType
                    ? ""
                    : "Select Source Type",
                }));
              }}
              placeholder="Select Source Type"
              // tabIndex="12"
              errorMessage={formDataError.sourceTypeError}
            />
          </div>

          <InputText
            inputType="text"
            title="Source"
            name="source"
            classStar="text-red-500"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.source || ""}
            placeholder="Enter Source"
            disabled={false}
            maxLength={50}
            // tabIndex="9"
            isRequired={true}
            errorMessage={formDataError.sourceError}
          />

          <InputText
            inputType="text"
            title="Contact Number"
            name="contactNumber"
            classStar="text-red-500"
            controlFunc={(e) => {
              const value = e.target.value;
              if (/^[0-9+\-\s]*$/.test(value)) {
                handleInputChange(e);
              }
            }}
            controlFuncBlur={handleBlur}
            content={formData?.contactNumber || ""}
            placeholder="Enter Contact Number"
            disabled={false}
            maxLength={15}
            // tabIndex="9"
            isRequired={true}
            errorMessage={formDataError.contactNumberError}
          />

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="idType"
              title="ID-Proof"
              type={"select-one"}
              classStar="text-red-500"
              options={data1[3] ?? []}
              selectedOption={formData?.idType}
              controlFunc={handleInputChange}
              // controlFuncBlur={handleBlur}
              controlFuncBlur={() => {
                setFormDataError(() => ({
                  ...formDataError,
                  idTypeError: formData.idType ? "" : "Select ID Type",
                }));
              }}
              placeholder="Select ID Type"
              // tabIndex="12"
              errorMessage={formDataError.idTypeError}
            />
          </div>

          <InputText
            inputType="text"
            title="ID-Number"
            name="idValue"
            classStar="text-red-500"
            controlFunc={handleInputChange}
            // controlFuncBlur={handleBlur}
            controlFuncBlur={() => {
              const value = (formData.idValue || "").toString().trim();
              let error = "";
              if (!value) {
                error = "Enter ID-Number";
              }
              setFormDataError({
                ...formDataError,
                idValueError: error,
              });
            }}
            content={formData?.idValue || ""}
            placeholder="Enter ID-Number"
            disabled={false}
            maxLength={20}
            // tabIndex="9"
            isRequired={true}
            errorMessage={formDataError.idValueError}
          />
{/* <InputText
  inputType="text"
  title="E-mail"
  name="email"
  classStar="text-red-500"
  controlFunc={handleInputChange}
  controlFuncBlur={() => {
    const value = (formData.email || "").toString().trim();
    let error = "";
    if (!value) {
      error = "Enter Email";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      error = "Enter a valid email address";
    }
    setFormDataError({
      ...formDataError,
      emailError: error,  
    });
  }}
  content={formData?.email || ""}
  placeholder="Enter email"
  disabled={false}
  maxLength={50}  
  // tabIndex="9"
  isRequired={true}
  errorMessage={formDataError.emailError}  
/> */}
        </div>
        <table className="min-w-full table-auto border border-gray-300 ">
          <thead className="bg-[#3D6643] text-white text-left">
            <tr>
              <th className="border px-2 py-2 w-[30px]">SN</th>
              <th className="border px-4 py-2 w-[270px]">Room Type</th>
              <th className="border px-4 py-2 w-[30px]">Available Rooms</th>
              <th className="border px-4 py-2 w-[160px]">Basic Tariff</th>
              <th className="border px-4 py-2 w-[160px]">Spl. Tariff</th>
              <th className="border px-4 py-2 w-[100px]">No. Of rooms</th>
              <th className="border px-2 py-2 w-[80px]">No. Of Adults</th>
              <th className="border px-2 py-2 w-[80px]">No. Of Children</th>
              <th className="border px-2 py-2 w-[150px]">Amount</th>
              {/* <th className="border px-4 py-2 w-[80px]">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {tableData.map((room, index) => (
              <tr key={index}>
                <td className="border px-2 py-2">{index + 1}</td>

                <td className="border px-4 py-2">
                  <DropDown
                    name="Rooms Type"
                    options={[{ value: room.RoomTypeId, label: room.RoomType }]}
                    placeholder="Select Room type"
                    selectedOption={room.RoomTypeId}
                    disabled={true}
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="availablerooms"
                    disabled={true}
                    content={room.AvailableRooms}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "AvailableRooms")
                    }
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="Tariff"
                    Class={mainTable.inputAmount}
                    content={room.Tariff}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "Tariff")
                    }
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="specialtariff"
                    content={room.specialtariff}
                    Class={mainTable.inputAmount}
                    disabled={false}
                    controlFunc={(e) =>
                      handletableDataChange(
                        e.target.value > 0 ? e.target : 0,
                        index,
                        "specialtariff"
                      )
                    }
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="numberofrooms"
                    content={room.Numberofrooms}
                    disabled={false}
                    controlFunc={(e) =>
                      handletableDataChange(
                        e.target.value > 0 ? e.target : 0,
                        index,
                        "Numberofrooms"
                      )
                    }
                  />
                </td>
                <td className="border px-2 py-2">
                  <InputText
                    name="numberofadults"
                    content={room.numberofadults}
                    disabled={false}
                    controlFunc={(e) =>
                      handletableDataChange(
                        e.target.value > 0 ? e.target : 0,
                        index,
                        "numberofadults"
                      )
                    }
                  />
                </td>
                <td className="border px-2 py-2">
                  <InputText
                    name="numberofchildren"
                    content={room.numberofchildren}
                    disabled={false}
                    controlFunc={(e) =>
                      handletableDataChange(
                        e.target.value > 0 ? e.target : 0,
                        index,
                        "numberofchildren"
                      )
                    }
                  />
                </td>
                <td className="border px-2 py-4">
                  <InputText
                    name="amount"
                    Class={mainTable.inputAmount}
                    content={tableData[index].amount}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "amount")
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-red-500 text-sm font-medium my-2">
          {tableDataError}
        </p>
        <div className={mainTable.grid3}>
          <div></div>
          <div></div>
          <div className="flex justify-end">
            <InputText
              title="Total"
              Class={mainTable.inputAmount}
              classDiv="flex gap-2 items-center justify-end mt-2 w-[170px]"
              name="quantity"
              content={formData?.bookingTotalAmount}
              controlFunc={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
        <div></div>

        <div className="mx-auto p-4 max-w-7xl">
          <ul className="space-y-4">
            {tableData?.map((room, index) => (
              <li
                key={index}
                className="border border-green-500 rounded-md p-4 shadow-sm bg-white"
              >
                <div className="flex flex-col  items-start  justify-between ">
                  {/* Checkbox & Button */}
                  <h2 className="text-lg font-semibold text-gray-800 mb-2">
                    {room.RoomType}
                  </h2>
                  <div className="flex flex-col md:flex-row items-start md:gap-x-10">
                    {/* Villa Image */}

                    <img
                      src={room.Photo}
                      alt="Room"
                      className="h-48 w-36 object-cover rounded-md border"
                    />
                    <div>
                      {/* Villa Info */}
                      <div className="flex-1 flex-col w-full">
                        <div className="flex flex-col md:flex-row md:gap-x-12 flex-1">
                          {/* Left Column */}
                          <div className="flex-2 space-y-1">
                            <p className="text-sm text-gray-600  font-semibold">
                              Room Details
                            </p>
                            <p className="text-sm text-gray-600">
                              Property Size:{room.Size}
                            </p>
                            <p className="text-sm text-gray-600">
                              Maximum Occupancy: {room.MaxOccupancy}
                            </p>
                            <p className="text-sm text-gray-600">
                              Villa Type: {room.RoomType}
                            </p>
                          </div>

                          {/* Center Column */}
                          <div className="flex-2 space-y-1">
                            <p className="text-sm text-gray-600 font-semibold ">
                              Space Details
                            </p>
                            {room.SpaceDetails ? (
                              <ul className="text-sm text-gray-600">
                                {room.SpaceDetails.split(",").map(
                                  (item, idx) => (
                                    <li key={idx}>
                                      {idx + 1}. {item.trim()}
                                    </li>
                                  )
                                )}
                              </ul>
                            ) : (
                              <p className="text-sm text-gray-600">
                                Space Details: Not Available
                              </p>
                            )}
                          </div>

                          {/* Right Column */}
                          <div className="flex-2 space-y-1">
                            <p className="text-sm text-gray-600 font-semibold">
                              AmenitiesDetails
                            </p>
                            {room.AmenitiesDetails ? (
                              <ul className="text-sm text-gray-600 ">
                                {room.AmenitiesDetails.split(",").map(
                                  (item, idx) => (
                                    <li key={idx}>
                                      {idx + 1}. {item.trim()}
                                    </li>
                                  )
                                )}
                              </ul>
                            ) : (
                              <p className="text-sm text-gray-600 ">
                                Amenities Details: Not Available
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="flex flex-row justify-between gap-8 mt-4">
                          <div className="flex flex-col gap-2">
                            <p className="text-sm font-semibold text-gray-700">
                              Rooms:{room.AvailableRooms}
                            </p>
                            <div className="flex gap-2 flex-wrap">
                            {(() => {
  const roomIds = (room.AvailableRoomsId || "")
    .split(",")
    .map(id => id.trim())
    .filter(id => id !== "");

  const roomNames = (room.AvailableRoomsName || "")
    .split(",")
    .map(name => name.trim())
    .filter(name => name !== "");

  return roomIds.map((roomIdStr, i) => {
    const roomId = Number(roomIdStr);
    const roomName = roomNames[i] || `Room ${roomId}`; 

    const isChecked = selectedRooms[index]?.includes(roomId) || false;
    const isMaxReached = (selectedRooms[index]?.length || 0) >= room.Numberofrooms;

    return (
      <label key={roomId} className="cursor-pointer">
        <input
          type="checkbox"
          className="hidden peer"
          checked={isChecked}
          disabled={!isChecked && isMaxReached}
          onChange={() => handleToggleRoom(index, roomId)}
        />
        <span
          className={`inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white transition ${
            isChecked
              ? "bg-red-800"
              : "bg-green-500 hover:bg-green-600"
          } ${
            !isChecked && isMaxReached
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
        >
          {roomName}
        </span>
      </label>
    );
  });
})()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        {/* {roomSelectionError != null && ( */}
        <p className="text-red-500 text-sm font-medium my-2">
          {roomSelectionError}
        </p>
        {/* )} */}
        <div className={mainTable.grid3}>
          <InputText
            Class={mainTable.inputAmount}
            inputType="text"
            title="Total Amount"
            name="bookingTotalAmount"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.bookingTotalAmount}
            placeholder="0.00"
            errorMessage={formDataError.bookingTotalAmountError}
            disabled={true}
            isRequired={true}
            // tabIndex="11"
            classStar="text-red-500"
          />

          <InputText
            Class={mainTable.inputAmount}
            inputType="text"
            title="Received Amount"
            name="bookingReceivedAmount"
            content={formData?.bookingReceivedAmount}
            // controlFunc={handleInputChange}
            // controlFunc={(e) =>
            //             setFormData({
            //               ...formData,
            //               bookingReceivedAmount: e.target.value,
            //               bookingBalanceAmount: formData.bookingTotalAmount - e.target.value,
            //             })
            //           }
            controlFunc={(e) => {
              const value = parseFloat(e.target.value) || 0;

              if (value <= formData.bookingTotalAmount) {
                setFormData({
                  ...formData,
                  bookingReceivedAmount: value,
                  bookingBalanceAmount: formData.bookingTotalAmount - value,
                });
              }
            }}
            controlFuncBlur={handleBlur}
            placeholder="0.00"
            errorMessage={formDataError.bookingReceivedAmountError}
            disabled={false}
            maxLength={8}
            isRequired={true}
            // tabIndex="11"
            classStar="text-red-500"
          />

          <InputText
            Class={mainTable.inputAmount}
            inputType="text"
            title="Balance Amount"
            name="bookingBalanceAmount"
            content={formData?.bookingBalanceAmount}
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            placeholder="0.00"
            disabled={true}
            isRequired={true}
            // tabIndex="11"
          />

          <DropDown
            name="bookingPaymentType"
            title="Payment Type"
            type={"select-one"}
            options={data1[5] ?? []}
            selectedOption={formData?.bookingPaymentType}
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            placeholder="Select Payment Type"
            // tabIndex="12"
            errorMessage={formDataError.bookingPaymentTypeError}
            classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Payment Reference Number"
            name="bookingPaymentReferenceNumber"
            controlFunc={handleInputChange}
            // controlFuncBlur={handleBlur}
            content={formData?.bookingPaymentReferenceNumber}
            placeholder=""
            disabled={false}
            isRequired={true}
            maxLength={20}
            // tabIndex="11"
            errorMessage={formDataError.bookingPaymentReferenceNumberError}
            // classStar="text-red-500"
          />
        </div>
        <FileUpload
          title="File Upload"
          // classStar="text-red-500"
          apiCall="Enquiry/BookingRefernceFileUpload"
          modalName="File"
          showImage={formData.showImage}
          showImageData={handleShowImage}
          disabledBtn={viewPopUp}
          imageUploadedError={formDataError.showImageError}
          clearImageUploadError={() =>
            setFormDataError({
              ...formDataError,
              showImageError: "",
            })
          }
          limitMassage={
            "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
          }
          MAX_FILE_SIZE_MB={2}
          ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
        />
      </div>
               {IsOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <Buttons
        addScreenTitle={viewPopUp ? false : true}
        updateScreenTitle={viewPopUp ? true : false}
        handleSubmit={handleSubmit}
        cancel={cancel}
        disabledBtn={submitBtnDisabled ? true : false}
      />
    </>
  );
};

export default ConfirmBookingPopUp;
